import { Button, Card, CardActions, CardContent, CardHeader, Divider, Modal, Switch, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Alert from 'src/components/Alert';
import SmsPermission from 'src/components/SmsPermission';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  divider: {
    backgroundColor: '#FF9800'
  },
}));

let PermissionChannel = [];
function CustomerPermisionModal({ open, onClose, customer, className }) {
  const classes = useStyles();
  const [values, setValues] = useState({ ...loadBaslandiJob() === undefined ? customer : loadBaslandiJob()[0] });
  const [alertVal, setAlertVal] = useState(false);
  const alertMessage = '';
  const [seconds, setSeconds] = React.useState(0);
  const [smsPermissionOpen, setSmsPermissionOpen] = React.useState(false);


  React.useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    }
  });



  const handleFieldChange = (event) => {
    event.persist();
    if (event.target.checked) {
      setSmsPermissionOpen(true)
      PermissionChannel.push(event.target.name);
    } else {
      PermissionChannel = PermissionChannel.filter((ete) => ete !== event.target.name);
    }
    setValues((currentValues) => ({
      ...currentValues,
      [event.target.name]:
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value
    }));
  };

  if (!open) {
    return null;
  }



  // const smsSend = (smskod, telefon) => {
  //   if (PermissionChannel.length > 0) {
  //     const smsText = "";
  //     const dataPermision = [{
  //       smsText: smsText,
  //       Phone: telefon,
  //       Brand: 'ARCELIK',
  //       CustomerNr: values.MusteriNo,
  //       ServicePaperNr: values.FisNo,
  //     }];
  //     const configPermision = {
  //       headers: { 'Content-Type': 'application/json' }
  //     };
  //     setSmsSent(true);
  //     const count = smsSentCount;
  //     setSmsSentCount(count + 1);
  //     axios.post('/SmsSendPermision', dataPermision, configPermision)
  //       .then(response => {
  //         if (response.data.length > 10) {
  //           openAlertMessage('Sms Müşteriye iletildi');
  //         } else {
  //           openAlertMessage('Sms Sunucu Kaynaklı Sms İletilemedi.');
  //         }
  //         setTimeout(() => setSmsSent(false), 30000);
  //         setSeconds(30);
  //       }).catch(error => {
  //         openAlertMessage('İç Sunucu Kaynaklı Sms İletilemedi.');
  //         setSmsSent(false);
  //       });

  //   }
  // };
  
  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card className={clsx(classes.root, className)}>
        <form>
          <CardHeader title="Müşteri KVKK İzinleri" />
          <Divider />
          <CardContent>
            <Switch
              checked={Boolean(values.AramaIzin)}
              color="primary"
              edge="start"
              name="AramaIzin"
              onChange={handleFieldChange}
              disabled={Boolean(loadBaslandiJob() === undefined ? values.AramaIzin : loadBaslandiJob()?.[0]?.AramaIzin)}
              value={values.AramaIzin}
            />
            <Typography variant="body1">Müşteri İzini</Typography>
            <Typography variant="body2">
              {!values.AramaIzin && 'Müşteri izinini aktif edebilirsiniz!...'}
              {PermissionChannel.filter((permission) => permission === 'AramaIzin').length === 0
                && values.AramaIzin === 1
                && 'CRM izni zaten mevcut! İzin kaldırma yetkiniz bulunmamaktadır.'}
              {PermissionChannel.filter((permission) => permission === 'AramaIzin').length > 0
                && values.AramaIzin && 'İzini onaylamak için lütfen işlemlerinize devam ediniz.'}
            </Typography>
            {smsPermissionOpen && <SmsPermission open={smsPermissionOpen} setOpen={setSmsPermissionOpen}
              PermissionChannela={PermissionChannel}
            />}
          </CardContent>
          {/* {
            (PermissionChannel.length > 0)
            && (
              <CardContent>
                <Divider className={classes.divider} />
                {
                  values.TelefonOffline !== ""  && values.TelefonOffline.substring(0, 1) === "5" ?
                    <Typography variant="body1">
                      <Button
                        color="secondary"
                        onClick={() => smsSend(values.SmsKod, values.TelefonOffline)}
                        variant="contained"
                        disabled={smsSent}
                        className={classes.submitButton}
                        endIcon={<SendIcon>Send</SendIcon>}
                      >
                        {(!smsSent && ((smsSentCount > 1) ? `(${smsSentCount})` : '') + values.Telefon + ' Tel1 Kodu Gönder') || (smsSent && `${seconds}snBekleyiniz..`)}
                      </Button>
                    </Typography>
                    : <div></div>
                }
                {
                  values.Telefon2Offline !== "" && values.Telefon2Offline.substring(0, 1) === "5" ?
                    <Typography variant="body1">
                      <Button
                        color="secondary"
                        onClick={() => smsSend(values.SmsKod, values.Telefon2Offline)}
                        variant="contained"
                        disabled={smsSent}
                        className={classes.submitButton}
                        endIcon={<SendIcon>Send</SendIcon>}
                      >
                        {(!smsSent && ((smsSentCount > 1) ? `(${smsSentCount})` : '') + values.Telefon2 + ' Tel2 Kodu Gönder') || (smsSent && `${seconds}snBekleyiniz..`)}
                      </Button>
                    </Typography>
                    : <div></div>
                }
                <Typography variant="body1">
                  <TextField id="outlined-basic"
                    label="İzin Onay Kodu" variant="outlined"
                    size="small" onChange={inputChange}
                    className={classes.submitButton}
                  />
                </Typography>
                <br />
                <Divider className={classes.divider} />
              </CardContent>
            )
          } */}

          <Divider />
          <CardActions className={classes.actions}>
            <Button
              color="secondary"
              variant="contained"
              endIcon={<CloseIcon>Close</CloseIcon>}
              onClick={onClose}
            >
              Kapat
            </Button>
            {/* <Button
              color="secondary"
              onClick={() => { save(values.SmsKod); }}
              variant="contained"
              endIcon={<SaveIcon>Save</SaveIcon>}
            >
              Kaydet
            </Button> */}
          </CardActions>
        </form>
        <div>
          {
            alertVal
            && (<Alert onClose={() => setAlertVal(false)} open={alertVal} message={alertMessage || ''} variant="success" />)
          }
        </div>
      </Card>
    </Modal>
  );
}

CustomerPermisionModal.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  smskod: PropTypes.string,
  smsSenta: PropTypes.bool,
  smsSentCounta: PropTypes.any,
  smsPermissionOpen: PropTypes.array,
};

CustomerPermisionModal.defaultProps = {
  open: false,
  smskod: '',
  onClose: () => { }
};

export default CustomerPermisionModal;
